import { render, staticRenderFns } from "./EnablingTypesRegistryList.vue?vue&type=template&id=09c1d5b4"
import script from "./EnablingTypesRegistryList.vue?vue&type=script&lang=js"
export * from "./EnablingTypesRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports